import { DynamicFieldFormat } from '@models/DynamicField';
import { FilterFnOption, SortingFnOption } from '@tanstack/table-core';

interface Output<TData> {
    filterFn?: FilterFnOption<TData>;
    sortingFn?: SortingFnOption<TData>;
    enableColumnFilter?: boolean;
}

export const getDefaultFilteringSorting = <TData>(format: DynamicFieldFormat, id: string): Output<TData> => {
    const lookupFields = ['wf_workflow', 'wf_status', 'wf_gebruiker', 'wf_bron'];

    return {
        ...(format === 'lookup' || lookupFields.includes(id)
            ? {
                  filterFn: 'select',
              }
            : format === 'text' || format === 'memo'
              ? {
                    filterFn: 'fuzzy',
                    sortingFn: 'alphanumeric',
                }
              : format === 'decimal' || format === 'int'
                ? {
                      filterFn: 'numeric',
                      sortingFn: 'numeric',
                  }
                : format === 'date' || format === 'time'
                  ? {
                        filterFn: 'dateRange',
                    }
                  : {
                        enableColumnFilter: false,
                    }),
    };
};
